$(function () {
    'use strict';

    window.huffpostReady.cb.forEach(function (callback) {
        callback();
    });
});